import script from "./About.vue?vue&type=script&setup=true&lang=js"
export * from "./About.vue?vue&type=script&setup=true&lang=js"

import "./About.vue?vue&type=style&index=0&id=e7cc12ce&scoped=true&lang=css"
script.__scopeId = "data-v-e7cc12ce"

export default script